<nav class="navbar navbar-expand-lg mb-3 navbar-light" role="navigation">
  <div class="container-fluid">
    <a class="navbar-brand">
      <img class="img-responsive" src="../../../assets/img/logo2.png" alt="App Logo"/>
      <span class="logo-text">  Partner Portal</span>
    </a>
    <ul class="nav navbar-nav navbar-right">
      <li>
        <div class="user-name">
          <em>Welcome, {{
            (productSetupService.productState$ | async)?.productData?.email ||
            (productSetupService.productState$ | async)?.groupData?.email || 'User'
            }}</em>
        </div>
      </li>
    </ul>
  </div>
</nav>
